import { render, staticRenderFns } from "./Associados.vue?vue&type=template&id=a2fdad40"
import script from "./Associados.vue?vue&type=script&lang=js"
export * from "./Associados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports